<template>
  <modal :id="modalId" size="small" @show="handleModalWillShow">
    <div class="add-product" v-if="!del">
      <span class="close-icon" @click="cancelAction">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
          <g clip-path="url(#clip0)">
            <path
              d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
              fill="#606770"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="10.6667"
                height="10.6667"
                fill="white"
                transform="translate(6.6665 6.66675)"
              />
            </clipPath>
          </defs>
        </svg>
      </span>
      <h3>{{ add ? "Add" : "Edit" }} Product</h3>
      <div class="h-18"></div>
      <b-form-group v-if="v2" label="Product Image">
        <image-upload ref="image-upload" :storage-path="productStoragePath" />
      </b-form-group>
      <b-form-group label="Name">
        <b-form-input
          type="text"
          required
          v-model="product.name"
          placeholder="Coffee Mug"
          :disabled="
            activeProductStatus == 'active' ||
              activeProductStatus == 'inactive' ||
              activeProductStatus == 'submitted'
          "
        />
      </b-form-group>
      <b-form-group label="Summary">
        <b-form-input
          type="text"
          required
          v-model="product.summary"
          placeholder="Enter your product summary here"
          :disabled="
            activeProductStatus == 'active' ||
              activeProductStatus == 'inactive' ||
              activeProductStatus == 'submitted'
          "
        ></b-form-input>
      </b-form-group>
      <b-form-group>
        <span class="description-name">
          <!-- {{ editMode ? "Edit" : "Add" }} description here -->
        </span>
        <transition name="fadeHeight" mode="out-in">
          <Editor
            id="textarea-default"
            v-show="true"
            @input="input"
            type="description"
            :clear="clear"
            :content="product.description"
            @resetClear="resetClear"
          />
        </transition>
      </b-form-group>
      <b-form-group label="SKU">
        <b-form-input
          type="text"
          required
          v-model="product.sku"
          placeholder="Enter your SKU here"
        />
      </b-form-group>
      <b-form-group label="ISBN">
        <b-form-input
          type="text"
          required
          v-model="product.isbn"
          placeholder="Enter your product name here"
        />
      </b-form-group>
      <!-- CREW -->
      <b-form-row class="half-fields">
        <b-form-group label="Price $">
          <b-form-input
            type="number"
            required
            v-model.number="product.price"
            placeholder="Add price of activation product"
          />
        </b-form-group>
        <b-form-group label="Primary Category">
          <b-form-input
            type="text"
            required
            v-model.number="product.categories"
            placeholder="Add category"
            :disabled="
              activeProductStatus == 'active' ||
                activeProductStatus == 'inactive' ||
                activeProductStatus == 'submitted'
            "
          ></b-form-input>
        </b-form-group>
      </b-form-row>
      <div class="mt-2 mb-2">
        <vue-taggable-select
          ref="tags"
          v-model="product.tags"
          :options="productTags"
          option-label="label"
          placeholder="Select Product Tags.."
          :taggable="true"
          :classes="{
            pill: 'pill'
          }"
        />
      </div>
      <b-form-group v-if="false" label="SEO">
        <b-form-input
          type="text"
          required
          v-model="seo"
          placeholder="Enter SEO Tags"
          @keypress.enter.prevent="addTag"
          :disabled="
            activeProductStatus == 'active' ||
              activeProductStatus == 'inactive' ||
              activeProductStatus == 'submitted'
          "
        ></b-form-input>
      </b-form-group>
      <div class="form-group">
        <div class="places-lived">
          <div
            class="place__places-lived"
            v-for="(seo, index) in product.seo"
            :key="index"
          >
            {{ seo }}
            <span class="ico del__ico" @click="delTag(seo)">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1 3C1 2.72386 1.22386 2.5 1.5 2.5H10.5C10.7761 2.5 11 2.72386 11 3C11 3.27614 10.7761 3.5 10.5 3.5H1.5C1.22386 3.5 1 3.27614 1 3Z"
                  fill="#FF8C7D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5 1.5C4.86739 1.5 4.74022 1.55268 4.64645 1.64645C4.55268 1.74021 4.5 1.86739 4.5 2V2.5H7.5V2C7.5 1.86739 7.44732 1.74021 7.35355 1.64645C7.25979 1.55268 7.13261 1.5 7 1.5H5ZM8.5 2.5V2C8.5 1.60217 8.34196 1.22064 8.06066 0.93934C7.77936 0.658035 7.39782 0.5 7 0.5H5C4.60218 0.5 4.22064 0.658035 3.93934 0.93934C3.65804 1.22064 3.5 1.60217 3.5 2V2.5H2.5C2.22386 2.5 2 2.72386 2 3V10C2 10.3978 2.15804 10.7794 2.43934 11.0607C2.72064 11.342 3.10217 11.5 3.5 11.5H8.5C8.89783 11.5 9.27936 11.342 9.56066 11.0607C9.84196 10.7794 10 10.3978 10 10V3C10 2.72386 9.77614 2.5 9.5 2.5H8.5ZM3 3.5V10C3 10.1326 3.05268 10.2598 3.14645 10.3536C3.24021 10.4473 3.36739 10.5 3.5 10.5H8.5C8.63261 10.5 8.75978 10.4473 8.85355 10.3536C8.94732 10.2598 9 10.1326 9 10V3.5H3Z"
                  fill="#FF8C7D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5 5C5.27614 5 5.5 5.22386 5.5 5.5V8.5C5.5 8.77614 5.27614 9 5 9C4.72386 9 4.5 8.77614 4.5 8.5V5.5C4.5 5.22386 4.72386 5 5 5Z"
                  fill="#FF8C7D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7 5C7.27614 5 7.5 5.22386 7.5 5.5V8.5C7.5 8.77614 7.27614 9 7 9C6.72386 9 6.5 8.77614 6.5 8.5V5.5C6.5 5.22386 6.72386 5 7 5Z"
                  fill="#FF8C7D"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
      <div v-if="v2" class="tools">
        <div>
          <h6>Apps:</h6>
          <div
            class="ico"
            @click="handleResouceBlocksClick"
            v-if="
              activeProductStatus !== 'inactive' &&
                activeProductStatus !== 'submitted'
            "
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="14"
                cy="14"
                r="14"
                fill="var(--theme-color)"
                fill-opacity="0.1"
              />
              <path
                d="M14 6V22"
                stroke="var(--theme-color)"
                stroke-width="2"
                stroke-linecap="round"
              />
              <path
                d="M6 14L22 14"
                stroke="var(--theme-color)"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <img
            v-for="(resource, i) in product.tools"
            :src="resource.imgURL"
            :key="i"
            :alt="resource.name"
            v-b-tooltip.hover
            :title="resource.name"
            width="30"
          />
        </div>
      </div>
      <div class="foot">
        <div class="d-flex justify-content-between">
          <b-button
            variant="primary"
            v-if="add"
            @click="handleAddProductClick"
            style="width: 100%"
            :disabled="!isEnabled"
          >
            Add
          </b-button>
          <b-button
            variant="primary btn-round-fill"
            @click="updatePublishing(product)"
            v-else
            :disabled="
              //product.description.trim().length > 0 &&
              product.name &&
              product.name.trim().length > 0 &&
              activeProductStatus !== 'inactive' &&
              activeProductStatus !== 'submitted'
                ? false
                : true
            "
          >
            Update
          </b-button>
        </div>
      </div>
    </div>
    <resources-store
      v-if="v2"
      :modal-id="modalIdResourcesBlocks"
      @updateResources="updateResources($event)"
    />
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/common/editor";
import ProductTags from "../../common/ProductTags";
import Modal from "@/components/common/modal";
import ImageUpload from "@/components/common/imageUpload";
import ResourcesStore from "./resourcesStore"; //TODO-  Make a component or bring in
import UploadImage from "@/mixins/UploadImage";
import VideoHandling from "@/mixins/VideoHandling";
import VueTaggableSelect from "@/components/common/multiselect/VueTaggableSelect"; //TODOMake a component or bring in

export default {
  name: "AddEditProductModal",
  mixins: [UploadImage, VideoHandling],
  components: {
    Editor,
    ImageUpload,
    Modal,
    ResourcesStore,
    VueTaggableSelect
  },
  props: {
    modalId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      v2: false,
      modalIdResourcesBlocks: "block-resources",
      productModal: "product-modal",
      productStoragePath: "rb_shop_product_img",
      product: {
        id: null,
        name: null,
        summary: null,
        description: {},
        sku: null,
        isbn: null,
        price: null,
        tools: [],
        keywords: [],
        seo: [],
        connections: [],
        imgURL: null,
        categories: ""
      },
      productTags: ProductTags,
      selectedProduct: {},
      selectedProductId: null,
      fetching: false,
      authorPublishingVideo: "author-product-video",
      refresh: 1,
      showCard: false,
      add: true,
      del: false,
      activeIndex: -1,
      activeCollapse: -1,
      isJustShown: false,
      searchStr: "",
      clear: false,
      content: [],
      seo: "",
      asset: "",
      popupText: "Copy to clipboard",
      uploadingImage: false,
      activeImage: "",
      imgDataUrl: "",
      imgURL: "",
      trackPassing: {},
      rolesArray: [],
      categoriesArray: [],
      activeVideo: null,
      processingVideo: false,
      activeProductStatus: null,
      activePublishing: null,
      showUpload: false,
      uploadingScreen: false,
      currIndex: ""
    };
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile",
      publishings: "user/listPublishings",
      getLocalPublishingWithId: "user/getLocalPublishingWithId"
    }),
    isEnabled() {
      return this.product.name && this.product.name.trim().length > 0;
    }
  },
  methods: {
    showAdd() {
      this.del = false;
      this.add = true;
      this.resetForm();
      this.$nextTick(function() {
        this.$bvModal.show(this.productModal);
      });
    },
    showEdit(product) {
      this.del = false;
      this.add = false;
      this.product = product;
      this.activeProductStatus = product.status;
      this.$nextTick(function() {
        this.$bvModal.show(this.productModal);
      });
    },
    handleModalWillShow() {
      console.log("being shown");
    },
    handleAddProductClick() {
      //if images available to uplaod
      this.product.id = this.generateId(7);
      if (
        this.$refs["image-upload"] &&
        this.$refs["image-upload"].images.length > 0
      ) {
        const images = this.$refs["image-upload"].handleUploadImage();
        this.products.images = images;
      }

      this.$emit("add-product", this.product);
    },
    getPublishings() {
      this.$emit("getPublishings");
      console.log("refresh Publishings");
    },
    handleSelectPublishingForManagement() {
      this.$store
        .dispatch("user/setSelectedPublishingId", this.selectedProduct.id)
        .then(data => {
          console.log(`Product Id submitted`);
          console.log(data);
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        })
        .finally(() => {
          this.fetching = false;
        });
    },
    updatePublishing(product) {
      const payload = {
        id: product.id,
        updates: product
      };

      this.$store.dispatch("user/updatePublishing", payload).then(res => {
        if (res) {
          this.$bvModal.hide(this.productModal);
          this.resetForm();
          this.getPublishings();
          this.$store.dispatch("user/showNotification", {
            title: "Publishings Updated Successfully",
            description: "Awesome",
            variant: "success"
          });
        }
      });
    },
    resetClear() {
      this.clear = false;
    },
    input(val) {
      this.product.description = val.content;
    },
    addTag() {
      if (this.seo && this.seo.trim() == "") return;
      this.product.seo.unshift(this.seo);
      this.seo = "";
    },
    delTag(tag) {
      let index = this.product.seo.indexOf(tag);
      if (index > -1) {
        this.product.seo.splice(index, 1);
      }
    },
    cancelAction() {
      this.resetForm();
      this.$bvModal.hide(this.productModal);
      this.refresh++;
    },
    generateId(length = 5) {
      //move to mixin
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      const timestamp = new Date().valueOf();
      return `${result}_${timestamp}`;
    },
    resetForm() {
      this.product = {
        name: "",
        summary: "",
        description: "",
        seo: [],
        tools: [],
        imgURL: "",
        price: 0,
        categories: "",
        age: 3
      };
      this.seo = "";
      this.activeIndex = null;
      this.activeProductStatus = null;
      this.content = {};
    },
    handleResouceBlocksClick() {
      this.$bvModal.show(this.modalIdResourcesBlocks);
    },
    updateResources(tools) {
      this.product.tools = tools;
    }
  },
  beforeMount() {},
  mounted() {
    console.log("Mounting");
    this.fetching = false;
    //this.$store.dispatch("user/getListNames");
    // this.$store.dispatch("user/getListRoles");
  }
};
</script>

<style lang="scss" scoped>
.product-foot {
  display: flex;
  justify-content: space-between;
  .stats {
    display: flex;
    align-items: center;
    .ico {
      margin: 0 17px;
    }
  }
  .collapse-foot {
    display: flex;
    justify-content: flex-end;
    .btn-simple-primary {
      background-color: #fff;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
      justify-content: center;
      padding: 8px 16px;
      border: none;
      display: flex;
      letter-spacing: 0.05em;
      align-items: center;
      color: var(--theme-color);
      margin-left: 16px;
      border-radius: 4px;
      transition: all 0.2s ease-in-out;
      svg {
        margin-right: 16px;
      }
      &:hover {
        background-color: #f3f6f9;
      }
      &.btn-start {
        background-color: #f3f6f9;
        &:hover {
          background-color: #dfdfdf;
          box-shadow: 0px 0px 4px 0px #eee;
        }
      }
    }
  }
}

.areas {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 25%;
  & > div {
    width: 60px;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
    }
    svg {
      cursor: pointer;
    }
  }
}
.small-check {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  margin-left: 24px;
}
.custom-control-label {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: #474d52;
}
.bv-no-focus-ring {
  position: relative;
  .pre {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #8d99a0;
  }
  .post {
    position: absolute;
    right: 15px;
    top: 50%;
    color: #8d99a0;
    transform: translateY(-50%);
  }
  input {
    padding-left: 30px;
  }
}
.add-publishings {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: var(--theme-color);
  cursor: pointer;
  position: relative;
}
.add-product {
  .foot {
    margin-top: 24px;
    border-top: 1px solid #dddddd;
    padding: 24px 0 10px 0;
  }
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
  .editor {
    max-width: 100%;
    width: 100%;
    .editor__content {
      .ProseMirror {
        width: 100%;
        border: none;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.8);
        border-radius: 20px;
        padding-left: 30px;
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #474d52;
        background: #fff;
        //border: 1px solid #ddd;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        height: 44px;
        -webkit-box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.8) !important;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.8) !important;
      }
    }
  }
}
.del-product {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}
.publishings {
  margin-top: 20px;
  .card {
    border: none;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    .details {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      & > div {
        margin-right: 18px;
        display: flex;
        align-items: center;
        svg {
          margin-right: 5px;
        }
      }
      .ico {
        margin: 0 17px;
        cursor: pointer;
      }
      .doc-ico {
        margin-left: 0;
      }
      .doc-link {
        color: var(--theme-color);
      }
    }
    .card-text {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #474d52;
    }
    .status-btn {
      display: inline-block;
      margin-right: 15px;
      width: 105px;
      height: 21px;
      font-family: Nunito;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      background: var(--theme-color);
      text-align: center;
      border: none;
      border-radius: 3px;
    }
  }

  .card-header {
    display: grid;
    grid-template-columns: 1fr 30px;
    align-items: center;
    padding: 0;
    .edit,
    .delete {
      display: none;
      cursor: pointer;
    }
    .btn-collapse {
      padding: 24px;
      text-align: left;
      box-shadow: none;
    }
    &.active {
      grid-template-columns: 1fr 30px 30px 30px;
      .edit,
      .delete {
        display: block;
      }
    }

    border: none;
    box-shadow: none;
    background: none;
  }
  .card-body {
    padding-top: 0;
    img {
      cursor: pointer;
      position: relative;
      // top: 50%;
      right: 4px;
      // -webkit-transform: translateY(-50%);
      // transform: translateY(-50%);
      height: 100px;
      width: 100px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      background: rgba(85, 126, 251, 0.1);
      border-radius: 8px;
    }
    .product-description {
      left: 5px;
    }
  }
}
.submit-btn {
  border-radius: 28px;
  width: 120px;
}
.roles {
  margin-top: 25px;
}
.tools {
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #eceff9;
  border-radius: 8px;
  padding: 12px 20px;
  position: relative;
  .extra-tools {
    position: absolute;
    top: 100%;
    width: 100%;
    left: 0;
    background-color: #fff;
    border: 1px solid #eceff9;
    border-top: 0;
    padding: 0px 11px 11px 11px;
    display: flex;
    justify-content: center;
  }
  .ico {
    cursor: pointer;
  }
  .ico,
  img {
    margin: 0 17px;
  }
  & > div {
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      color: #5b606c;
      margin: 0 10px 0 0;
    }
  }
  .engine {
    margin-top: 3px;
    background-color: rgba(85, 126, 251, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: var(--theme-color);
    margin-right: 7px;
    svg {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  h6 {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 33px;
    display: inline;
    color: #5b606c;
    margin-right: 10px;
    //   margin-bottom: 0;
  }
}
.video-sec {
  margin-left: 15px;
}

.description-name {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
  max-width: 354px;
  width: 100%;
  margin: 18px 0;
  cursor: pointer;
}
.half-fields {
  margin-left: 3px;
}
.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.5s;
  max-height: 230px;
}
.fadeHeight-enter,
.fadeHeight-leave-to {
  opacity: 0;
  max-height: 0px;
  overflow: hidden;
}
</style>
